import querystring from 'query-string'
import get from 'lodash/get'

import { customHistory as history } from '../routingHelper/routerHistory'

export function pushNewStateToHistory(queryObj) {
  history.replace({
    pathname: history.location.pathname,
    search: querystring.stringify(queryObj),
  })
}

export function isHistoryAvailable(history = {}) {
  return get(history, 'location.search', false)
}
